import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

// grey box naming the email template a setting sends, with the button that opens Communications › Email templates
// (Automatic reply 713:6606, Consent 713:5854)
const TemplateCard: React.FC<{ intro: string; name: string; button: string; off?: boolean }> = ({ intro, name, button, off }) => {
    const history = useHistory();
    return <div className={`hub-fs-template${off ? ' is-off' : ''}`}>
        <p>{intro}</p>
        <div className="hub-fs-template-row">
            <span className="badge ok">Assigned</span>
            <strong>{name}</strong>
            <button type="button" className="btn-outline" onClick={() => history.push('/communications')}>{button} <FiArrowRight /></button>
        </div>
        <small>Opens Communications › Email templates</small>
    </div>;
};

export default TemplateCard;
